import { isExecutive, isOrganizationAdmin, isReportingManager, type Role } from "@packages/core/session/roles.ts";

export const TEAM_ACCESS: readonly Role[] = [isReportingManager, isExecutive];

export const TEAM_ONBOARDING_ACCESS: readonly Role[] = [isOrganizationAdmin];
